<div class="container">
  <div class="month-header-row">
    <div class="month-cell region"></div>
    <div *ngFor="let m of monthHeaders" class="month-cell text" [style.min-width]="(m.span * 50 - 8) + 'px'">
      <div class="month">{{ m.month }}</div>
    </div>
  </div>

  <mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="regions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.region }}</mat-cell>
    </ng-container>

    <ng-container *ngFor="let column of displayedColumns.slice(1)" [matColumnDef]="column">
      <mat-header-cell *matHeaderCellDef>
        {{ column.split('-')[3] }}
      </mat-header-cell>

      <mat-cell *matCellDef="let element"
                [style.background-color]="getColumnValue(element, column)?.color || '#EDEDED'"
                [style.border-color]="getColumnValue(element, column)?.color?.slice(0, -2) || '#EDEDED'"
      >
        <span>{{ getColumnValue(element, column)?.value }}</span>
      </mat-cell>
    </ng-container>

    <mat-header-row [class.has-summary-row]="dataSource.data.length > 1" *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row [class.has-summary-row]="dataSource.data.length > 1" *matRowDef="let row; columns: displayedColumns" [style.min-width]="(rowWidth * 50 - 8) + 'px'"></mat-row>
  </mat-table>
</div>
